module.exports = __webpack_public_path__ + "static/media/face.cbeeb1ab.png";